import { objects, predicates } from "friendly-words";
export const randomElement = (arr: string[]) =>
  arr[Math.floor(Math.random() * arr.length)];

export const randomName = (): string =>
  [predicates, objects].map(randomElement).join("-");
